import { Link, Navigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container } from 'styles/container.styles';
import { getGuideBySlug, GUIDES } from 'data/guides';
import AdSense from 'components/AdSense';
import { ADSENSE_SLOTS } from 'config/adsense.config';
import { SITE_URL } from 'config/seo.config';
import { GuideDetailContainer } from '../styles';

const GuideDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const guide = slug ? getGuideBySlug(slug) : undefined;

  if (!guide) {
    return <Navigate to='/guide' replace />;
  }

  const currentIndex = GUIDES.findIndex((item) => item.slug === guide.slug);
  const prev = currentIndex > 0 ? GUIDES[currentIndex - 1] : null;
  const next =
    currentIndex < GUIDES.length - 1 ? GUIDES[currentIndex + 1] : null;

  const canonical = `${SITE_URL}/guide/${guide.slug}`;

  return (
    <>
      <Helmet>
        <title>{`${guide.title} - 마트통포스`}</title>
        <meta name='description' content={guide.description} />
        <link rel='canonical' href={canonical} />
        <meta property='og:title' content={`${guide.title} - 마트통포스`} />
        <meta property='og:description' content={guide.description} />
        <meta property='og:url' content={canonical} />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: guide.title,
            description: guide.description,
            datePublished: guide.publishedAt,
            author: {
              '@type': 'Organization',
              name: '마트통포스',
            },
            publisher: {
              '@type': 'Organization',
              name: '마트통포스',
              url: SITE_URL,
            },
            mainEntityOfPage: canonical,
          })}
        </script>
      </Helmet>

      <Container>
        <GuideDetailContainer>
          <div className='guide-detail__meta'>
            <span className='guide-detail__category'>{guide.category}</span>
            <time dateTime={guide.publishedAt}>{guide.publishedAt}</time>
            <span>읽는 시간 약 {guide.readingMinutes}분</span>
          </div>

          <h1>{guide.title}</h1>
          <p className='guide-detail__lead'>{guide.description}</p>

          {guide.sections.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 24)}>{paragraph}</p>
              ))}
            </section>
          ))}

          <AdSense slot={ADSENSE_SLOTS.inArticle} />

          <div className='guide-detail__nav'>
            {prev ? (
              <Link to={`/guide/${prev.slug}`}>← {prev.title}</Link>
            ) : (
              <span />
            )}
            {next ? (
              <Link to={`/guide/${next.slug}`}>{next.title} →</Link>
            ) : (
              <span />
            )}
          </div>

          <div className='guide-detail__nav'>
            <Link to='/guide'>전체 가이드 목록</Link>
            <Link to='/faq'>자주 묻는 질문</Link>
            <Link to='/contact'>도입 상담 문의</Link>
          </div>
        </GuideDetailContainer>
      </Container>
    </>
  );
};

export default GuideDetail;
